import Router from "./router.js";

function App() {
	return (
		<div className="appContainer ms-auto me-auto">
			<Router />
		</div>
	);
}

export default App;
